import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import MyButton from "./MyButton";

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: 1,
  },
  paper: {},
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 250,
  },
};

class SuKienXuLyDiDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      sukien: {
        nguontin: "HCM RADIO",
      }, //thong tin ve su kien
    };
  }
  render() {
    return <div>Hello</div>;
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.props.fullWidth}
          maxWidth={this.props.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">Cập nhật sự vụ - Xử lý thông tin đi</DialogTitle>
          <DialogContent>
            <form style={styles.form} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tên sự vụ:" />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Số hồ sơ:" />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian(HN):"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Nơi nhận:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>HCM RADIO</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>
                        VUNG TAU RADIO
                      </MenuItem>
                      <MenuItem value={"KHAC"}>KHAC</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tên đơn vị:" />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Phương thức gửi:" />
                </Grid> 
                <Grid item xs={6}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Loại thông tin:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>Báo cáo cấp trên</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>
                        Thông báo hàng hải
                      </MenuItem>
                      <MenuItem value={"KHAC"}>Thông báo cho chủ tàu</MenuItem>
                      <MenuItem value={"KHAC"}>Thông tin khác</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>                        
                <Grid item xs={12}>
                  <TextField id="txtTentau" label="Mô tả nội dung thông tin:" />
                </Grid> 
                <Grid item xs={12}>
                  <TextField id="txtTentau" label="Mô tả vụ việc:" />
                </Grid>                 
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 1
                    <input type="file" hidden />
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 2
                    <input type="file" hidden />
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 3
                    <input type="file" hidden />
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 4
                    <input type="file" hidden />
                  </Button>
                </Grid>                              
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <MyButton onClick={this.handleClose} color="primary" text="Lưu" />
            <MyButton onClick={this.handleClose} color="primary" text="Thoát" />
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default SuKienXuLyDiDialog;
